function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h20v2H0zM0 16h20v2H0zM0 8h20v2H0z"
}));

var SvgHamburger = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 18,
  viewBox: "0 0 20 18"
}, props), _ref);

export default SvgHamburger;